module.exports = __webpack_public_path__ + "img/130.e1098961.jpg";